/* eslint-disable */
import React, { useEffect } from 'react';

import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { uiActions } from '../../store/ui-slice';
import { form6FetchCatalogs, fetchUsesOfTheVehicle } from '../../store/catalogs-actions';
import { form6Transaction } from '../../store/forms/form6-actions';
import { catalogsActions } from '../../store/catalogs-slice';

import FieldSelect from '../commons/FieldSelect';
import Button from '../commons/Button';
import FieldText from '../commons/FieldText';

import { doNavigation } from '../../utils/helper-functions';
import { FORM6_VALIDATION_SCHEMA } from '../../constants/validation-schemas';

const Form6 = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.appConfig.appToken);
  const idProcess = useSelector((state) => state.appConfig.idProcess);
  const form6State = useSelector((state) => state.form6);
  const vehiclesTypes = useSelector((state) => state.catalogs.vehiclesTypes);
  const usesOfTheVehicle = useSelector((state) => state.catalogs.usesOfTheVehicle);
  const vehicleServices = useSelector((state) => state.catalogs.vehicleServices);
  const navigate = useNavigate();
  const currentStep = useSelector((state) => state.appConfig.quoterCurrentStep);
  const quoteId = useSelector(({ form3: { selectedPeriodicity, coverageObject } }) => (
    coverageObject?.forma_pagos[selectedPeriodicity]?.cotizacion?.numeroCotizacion
  ));
  const preferredBeneficiary = useSelector((state) => state.catalogs.preferredBeneficiary);
  const prevFormData = {
    form2: useSelector((state) => state.form2),
    form3: useSelector((state) => state.form3),
    form4: useSelector((state) => state.form4),
    form5: useSelector((state) => state.form5),
  };

  const submitHandler = (values) => {
    dispatch(uiActions.setConfirmStatus({
      title: '¡Hola!',
      message: 'Nos encontramos a un paso de generar tu póliza. Te pedimos que confirmes que toda la información que captures es correcta y precisa antes de avanzar, ya que una vez que lo hagamos, no podrás realizar ninguna modificación.',
      buttonLabel: 'Continuar',
      buttonIcon: 'arrow-right',
      buttonIconPosition: 'after',
      buttonAction: () => dispatch(form6Transaction(
        token,
        idProcess,
        quoteId,
        values,
        preferredBeneficiary,
        prevFormData,
        currentStep,
        navigate,
      )),
      cancelButtonLabel: 'Regresar',
      cancelButtonIcon: 'arrow-left',
      cancelButtonPosition: 'before',
    }));
  };

  const navigationHandler = (direction) => {
    doNavigation(currentStep, direction, navigate, dispatch, uiActions, true);
  };

  const onChangeVehicleType = (value, setFieldValue) => {
    if (value) {
      dispatch(fetchUsesOfTheVehicle(token, value, setFieldValue));
    } else {
      dispatch(catalogsActions.setUsesOfTheVehicle({ usesOfTheVehicle: [] }));
      setFieldValue('useOfTheVehicle', '');
    }
  };

  useEffect(() => {
    if (token) {
      dispatch(form6FetchCatalogs(token));
    }
  }, [dispatch, token]);

  return (
    <Formik
      onSubmit={submitHandler}
      enableReinitialize
      initialValues={form6State}
      validateOnMount={!form6State.wasValidatedBefore}
      validationSchema={Yup.object().shape(FORM6_VALIDATION_SCHEMA)}>
      {({ isValid }) => {
        return (
          <Form className="quoter-form">
            <h2 className="form-title">
              Datos del vehículo.
            </h2>
            <p className="form-subtitle text-center">
              Ingresa tus datos del vehículo para emitir tu póliza.
            </p>
            <h3>
              Datos específicos del vehículo
            </h3>
            <hr className="solid" />
            <div className="form-fields">
              <div className="field-row">
                <FieldText
                  label="Número de serie"
                  name="serialNumber"
                  maxLength={17}
                  required />
                <FieldText
                  label="Número de motor"
                  name="engineNumber"
                  maxLength={60}
                  required />
              </div>
              <div className="field-row">
                <FieldText
                  label="Placa"
                  name="plate"
                  maxLength={7}
                  required />
                <FieldSelect
                  isDisabled
                  label="Tipo de servicio del vehículo"
                  list={vehicleServices}
                  keyLabel="name"
                  keyName="id"
                  name="vehicleService" />
              </div>
              <div className="field-row">
                <FieldSelect
                  isDisabled
                  label="Tipo de vehículo"
                  onChangeCallback={onChangeVehicleType}
                  list={vehiclesTypes}
                  keyLabel="name"
                  keyName="id"
                  name="vehicleType" />
                <FieldSelect
                  isDisabled
                  label="Uso del vehículo"
                  list={usesOfTheVehicle}
                  keyLabel="name"
                  keyName="id"
                  name="useOfTheVehicle" />
              </div>
            </div>
            <div className="form-buttons">
              <Button
                onClick={() => navigationHandler('backward')}
                type="button"
                label="Regresar"
                buttonClasses="-secondary"
                iconPosition="before"
                iconClasses="arrow-left" />
              <Button
                type="submit"
                disabled={!isValid}
                label="Continuar"
                iconClasses="arrow-right" />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default Form6;
